import Slider from 'react-slick';
import { StoryboardItem } from './StoryboardItem';
import { NextArrow, PrevArrow } from '@/components/SliderArrows';
import type { StoryboardItemFragment } from '@/utils/dato/generated';
import { useBreakpointValue } from '@/utils/hooks/useBreakpointValue';

type StoryboardSliderProps = {
  items: StoryboardItemFragment[];
};

const SLIDES_TO_SHOW_BREAKPOINTS = [
  { maxWidth: 768, value: 1 },
  { maxWidth: 1200, value: 2 },
];

export const StoryboardSlider = ({ items }: StoryboardSliderProps) => {
  const slidesToShow = useBreakpointValue(SLIDES_TO_SHOW_BREAKPOINTS, 3);

  if (!items.length || slidesToShow === undefined) {
    return null;
  }

  return (
    <div className="relative [&_.slick-track]:mx-auto" aria-label="Product showcase" role="region">
      <Slider
        slidesToShow={slidesToShow}
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        slidesToScroll={1}
        infinite={false}
        dots={false}
        arrows
      >
        {items.map(({ id, ...rest }) => (
          <StoryboardItem key={id} id={id} {...rest} />
        ))}
      </Slider>
    </div>
  );
};
